import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, bool_type, equals, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";

export class CsrfTokenDTO extends Record {
    constructor(csrfToken) {
        super();
        this.csrfToken = csrfToken;
    }
}

export function CsrfTokenDTO$reflection() {
    return record_type("Containers.Login.Api.CsrfTokenDTO", [], CsrfTokenDTO, () => [["csrfToken", string_type]]);
}

export function getCSRFCookie() {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/auth/csrf-token/"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(CsrfTokenDTO$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(CsrfTokenDTO$reflection(), arg, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(CsrfTokenDTO$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

class LoginInputDTO extends Record {
    constructor(username, password, hashUrl) {
        super();
        this.username = username;
        this.password = password;
        this.hashUrl = hashUrl;
    }
}

function LoginInputDTO$reflection() {
    return record_type("Containers.Login.Api.LoginInputDTO", [], LoginInputDTO, () => [["username", string_type], ["password", string_type], ["hashUrl", string_type]]);
}

export class LoginOutputDTO extends Record {
    constructor(success, requiresOtp, message) {
        super();
        this.success = success;
        this.requiresOtp = requiresOtp;
        this.message = message;
    }
}

export function LoginOutputDTO$reflection() {
    return record_type("Containers.Login.Api.LoginOutputDTO", [], LoginOutputDTO, () => [["success", bool_type], ["requiresOtp", bool_type], ["message", string_type]]);
}

export function postLogin(username, password, hashUrl) {
    const loginDTO = new LoginInputDTO(username, password, hashUrl);
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/auth/login/"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(LoginOutputDTO$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(LoginOutputDTO$reflection(), arg, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(LoginInputDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(loginDTO));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

class LoginOtpInputDTO extends Record {
    constructor(username, otp) {
        super();
        this.username = username;
        this.otp = otp;
    }
}

function LoginOtpInputDTO$reflection() {
    return record_type("Containers.Login.Api.LoginOtpInputDTO", [], LoginOtpInputDTO, () => [["username", string_type], ["otp", string_type]]);
}

export class LoginOtpOutputDTO extends Record {
    constructor(success, message) {
        super();
        this.success = success;
        this.message = message;
    }
}

export function LoginOtpOutputDTO$reflection() {
    return record_type("Containers.Login.Api.LoginOtpOutputDTO", [], LoginOtpOutputDTO, () => [["success", bool_type], ["message", string_type]]);
}

export function postOtp(username, otp) {
    const loginOtpDTO = new LoginOtpInputDTO(username, otp);
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, "/auth/login/otp"));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1) => {
            const str = arg_1;
            return equals(LoginOtpOutputDTO$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(LoginOtpOutputDTO$reflection(), arg, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(LoginOtpInputDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(loginOtpDTO));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

